import { OpenTypeFeature } from "@/shared/fontMeta";
import { groupBy, mapValues } from "lodash";

export type FeatureSelectorFeature = {
  name: string;
  operation: "exclude" | "freeze";
  value: string;
  values: { value: string; name: string }[];
  sample: string | null;
  isPremium: boolean;
};

export type FeatureSelectorFeatures = Record<string, FeatureSelectorFeature>;

const featuresToExclude = [
  "frac",
  "sups",
  "subs",
  "onum",
  "sinf",
  "dnom",
  "ordn",
  "case",
  "numr",
];

/**
 * Convert shared open type features data set to a format that can be used by the
 * feature selector component:
 * "alt g": {
 *   operation: "freeze",
 *   sample: "g",
 *   value: "",
 *   values: [
 *     { value: "", name: "default g" },
 *     { value: "ss03", name: "alt g 1" },
 *     { value: "ss04", name: "alt g 2" },
 *   ],
 * },
 */
export function getFreezableFeatures(
  features: ReadonlyArray<OpenTypeFeature>,
): FeatureSelectorFeatures {
  const filteredFeatures = features.filter((feature) => {
    return (
      feature.label !== null &&
      feature.sample !== null &&
      !featuresToExclude.includes(feature.tag)
    );
  });
  return mapValues(
    groupBy(filteredFeatures, (feature) => feature.label),
    (group) => {
      const feature = group[0];
      const res: FeatureSelectorFeature = {
        name: feature.label ?? feature.tag,
        sample: feature.sample,
        isPremium: feature.isPremium,
        operation:
          feature.tag === "calt" || feature.tag === "liga"
            ? "exclude"
            : "freeze",
        value: "",
        values: [
          // Add the default value
          {
            value: "",
            name: "default",
          },
          ...group.map((item) => ({
            value: item.tag,
            name: item.label ?? item.tag,
          })),
        ],
      };
      return res;
    },
  );
}
